"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const UserInterface_1 = require("./UserInterface");
const DocumentSettingsContext_1 = require("../../context/DocumentSettingsContext");
const TemplateSelectionWrapper_1 = __importDefault(require("./TemplateSelectionWrapper"));
const DocumentBuilderLayout = ({ newTemplateGenerate }) => {
    return ((0, jsx_runtime_1.jsx)(DocumentSettingsContext_1.DocumentSettingsProvider, { children: (0, jsx_runtime_1.jsx)(TemplateSelectionWrapper_1.default, { newTemplateGenerate: newTemplateGenerate, children: (0, jsx_runtime_1.jsx)(UserInterface_1.UserInterface, { newTemplateGenerate: newTemplateGenerate }) }) }));
};
exports.default = DocumentBuilderLayout;
